import { Car, Clock, MessageSquare } from "lucide-react";
import { fileUrl, fmtDate } from "@/lib/api";

export const JobDetails = ({ job, token }) => (
  <div className="grid lg:grid-cols-3 gap-5" data-testid={`job-details-${job.reference}`}>
    <div className="rounded-2xl bg-[#020165] text-white p-6 space-y-3">
      <p className="text-xs uppercase tracking-widest text-[#F86900] font-bold">{job.reference}</p>
      <h3 className="font-display text-xl font-bold">{job.service_title}</h3>
      {(job.vehicle?.make || job.vehicle?.registration) && <p className="flex items-center gap-2 text-sm text-white/75"><Car className="h-4 w-4" />{[job.vehicle?.year, job.vehicle?.make, job.vehicle?.model].filter(Boolean).join(" ")} {job.vehicle?.registration && `· ${job.vehicle.registration}`}</p>}
      <p className="flex items-center gap-2 text-sm text-white/75"><Clock className="h-4 w-4" />Estimated completion: {fmtDate(job.planned_completion)}</p>
      <p className="text-sm">Current stage: <strong className="text-[#F86900]" data-testid="job-current-status">{job.status}</strong></p>
    </div>
    <div className="rounded-2xl bg-white p-6">
      <h4 className="font-display font-bold flex items-center gap-2"><MessageSquare className="h-4 w-4 text-[#F86900]" />Workshop updates</h4>
      <ul className="mt-3 space-y-2 text-sm text-[#1D1E20]" data-testid="job-customer-notes">
        {job.customer_notes?.length ? job.customer_notes.map((n, i) => <li key={i} className="border-l-2 border-[#F86900] pl-3">{n}</li>) : <li className="text-[#56585E]">No updates yet.</li>}
      </ul>
    </div>
    <div className="rounded-2xl bg-white p-6">
      <h4 className="font-display font-bold">Progress photos</h4>
      <div className="mt-3 grid grid-cols-3 gap-2" data-testid="job-progress-photos">
        {job.progress_photos?.length ? job.progress_photos.map((p, i) => {
          const id = p.url?.split("/").pop();
          return <a key={i} href={fileUrl(id, token)} target="_blank" rel="noreferrer"><img src={fileUrl(id, token)} alt={p.caption || ""} className="aspect-square w-full object-cover rounded-lg" /></a>;
        }) : <p className="col-span-3 text-sm text-[#56585E]">Photos appear here as work progresses.</p>}
      </div>
    </div>
  </div>
);
